<template>
  <router-view />
</template>

<script>
export default {
  name: 'campaign-pages-container',
};
</script>
